import React from "react";

export const FAQS = React.lazy(() => import("./FAQS/index.page"));
export const CmsPages = React.lazy(() => import("./CmsPages/index"));
